module.exports = "/assets/8ffb2efcdcf7dc3512c3634f8bbf448b.svg";